import React from "react";
import { AiOutlineForm } from 'react-icons/ai';

const CertTrad = () => {
    return (
        <div className='pt-10'>
            <div className=" p-6 max-w-2xl mx-auto bg-white rounded-xl shadow-md flex items-center flex-col">            
                <h1 className=' font-bold text-principal text-2xl pb-4 font-sans'>Certificados de Tradición</h1>

                <p className='text-xl font-sans text-center'>
                    El Certificado de Tradicion y libertad es un documento sobre un predio que  emite la Superintencia de Notariado y Registro de Colombia. Dicho documento contiene todo el historial del predio incluyendo el historial de propietarios ordenados cronológicamente junto con una descripción del mismo. Para obtenerlo debe tener el número de Matricula Inmobiliaria.
                </p>

                <a
                    href={`https://wa.me/+573104032213?text=Hola,%20quiero%20solicitar%20información%20sobre%20Contratos%20de%20Certificados%20de%20Tradición.`} target="_blank" rel="noopener noreferrer"
                    className='text-center bg-principal text-white py-2 px-6 rounded-full border-2 border-principal font-semibold mt-4 hover:bg-white hover:text-principal hover:scale-95 transition-all duration-200 ease-out'>
                    <AiOutlineForm size={25} className='inline-block mr-2' />
                    Solicitar
                </a>
            </div>
        </div>
    );
}

export default CertTrad;